import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from './utils';

const statusBadgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-muted text-muted-foreground',
        success: 'bg-[#C0E281]/30 text-green-800',
        warning: 'bg-[#EED68A]/40 text-amber-800',
        error: 'bg-[#EF8888]/30 text-red-800',
        info: 'bg-primary/10 text-primary',
        bookmark: 'bg-[#EF8888]/30 text-red-800',
        skipped: 'bg-[#EED68A]/40 text-amber-800',
        answered: 'bg-[#C0E281]/30 text-green-800',
        partial: 'bg-[#F3BB51]/30 text-amber-800',
        correct: 'bg-[#C0E281]/30 text-green-800',
        incorrect: 'bg-[#EF8888]/30 text-red-800',
        notVisited: 'bg-black/10 text-muted-foreground'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

function StatusBadge({ className, variant, children, dot = false, ...props }) {
  return (
    <span className={cn(statusBadgeVariants({ variant }), className)} {...props}>
      {dot && (
        <span
          className="h-1.5 w-1.5 rounded-full bg-current opacity-70"
          aria-hidden
        />
      )}
      {children}
    </span>
  );
}

export { StatusBadge, statusBadgeVariants };
